import {apiService} from '../services/ApiService';
import {useQuery} from 'react-query';

function useUserPermissions() {

    const fetchDataUser = async () => {
        try {
            const responseUser = await apiService.getMe();

            return ({
                ...responseUser.data,
            });
        } catch (error) {
        }
    };

    return useQuery({
        queryKey: ['currentUserUseMe'],
        queryFn: fetchDataUser,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        retry: false,
        staleTime: Infinity,
        cacheTime: Infinity,
    });
}

export default useUserPermissions;
